import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { FsTransactionRowWithBarGraphDataProps } from 'ui-elements/tables/FsTransactionRowsWithBarGraph/FsTransactionRowWithBarGraph/FsTransactionRowWithBarGraph';
import {
  RecurringTransactionsSingleRow,
  RecurringTransactionsSingleRowProps,
} from './recurring-transactions-single-row';

export interface RecurringTransactionsProps {
  data: RecurringTransactionsSingleRowProps[];
  status: LoadingState;
}

export const RecurringTransactions = types
  .model({
    data: types.optional(types.array(RecurringTransactionsSingleRow), []),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: RecurringTransactionsProps): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        ...props,
      };
      applySnapshot(self, newSnapshot);
    },
    updateStatus(status: LoadingState): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        status,
      };
      applySnapshot(self, newSnapshot);
    },
  }))
  .views((self) => ({
    rows(): FsTransactionRowWithBarGraphDataProps[] {
      return self.data.map(({ price, graphs, ...otherProps }) => ({
        ...otherProps,
        price: price.displayValue(),
        graphs: graphs.map((graph) => graph.singleBarGraphValues()),
      }));
    },
  }));
